function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import Icon from './IconBase';

var IconCheckmarkSmallOutline = function IconCheckmarkSmallOutline(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    viewBox: "0 0 14 14"
  }, props, {
    width: "14",
    height: "14"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.857 10.556L2.293 6.993a.999.999 0 111.414-1.415l2.15 2.15 4.436-4.435a1 1 0 011.414 1.413l-5.85 5.85z"
  }));
};

export default IconCheckmarkSmallOutline;